import { apolloClient } from "../../vue-apollo";
import { exMut } from "../../graphql/gql";

import {
  GET_PLANIFICACIONES,
  GET_USUARIO,
  GET_PLANIFICACION_ID,
  GET_TURNOS,
  GET_TEAMS,
  GET_TIPO_TRANSPORTE_EMPRESA,
  GET_TRAMOS,
  GET_TIPO_IDA_VUELTA,
  GET_SOLICITUDES_USUARIO,
  GET_TRAMOS_APP_VUELTA,
} from "../../graphql/queries";
import {
  CREAR_INSCRIPCION_TRAMO,
  CANCELAR_INSCRIPCION_TRAMO,
} from "../../graphql/mutations";
import { exQue } from "../../graphql/gql";

export default {
  namespaced: true,
  state: {
    planificaciones: [],
    getOnePlanificacionID: [],
    usuario: [],
    turnos: [],
    teams: [],
    tipoTransporte: [],
    GetTramosApp: [],
    tipoIdaVuelta: [],
    solicitudes: [],
  },
  getters: {},
  mutations: {
    GET_TRAMOS_APP_VUELTA_LIST(state, tramos) {
      tramos.forEach((t) => {
        let date = new Date(t.fecha_viaje + "T00:00:00");
        let month =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        let year = date.getFullYear();
        t.tramo =
          t.transporte_lista_destino.nombre_origen +
          " - " +
          t.transporte_lista_destino.nombre_destino +
          " (" +
          day +
          "-" +
          month +
          "-" +
          year +
          ") ";
        t.asientos = t.asientos.map((asiento) =>
          Object.assign(asiento, { selected: false })
        );
      });
      state.tramosAppVuelta_list = tramos;
    },
    SET_PLANIFICACIONES(state, planificaciones) {
      state.planificaciones = planificaciones;
    },
    SET_PLANIFICACION(state, planificacion) {
      state.getOnePlanificacionID = planificacion;
    },
    SET_USUARIO(state, usuario) {
      state.usuario = usuario;
    },
    SET_TURNOS(state, turnos) {
      state.turnos = turnos;
    },
    SET_TEAMS(state, teams) {
      state.teams = teams;
    },
    SET_TIPO_TRANSPORTE(state, tipoTransporte) {
      state.tipoTransporte = tipoTransporte;
    },
    SET_TRAMOS_TRANSPORTE(state, tramos) {
      tramos.forEach((tramo) =>
        tramo.asientos.map((asiento) =>
          Object.assign(asiento, { selected: false })
        )
      );
      state.GetTramosApp = tramos;
    },
    SET_TIPO_IDA_VUELTA(state, tipoViaje) {
      state.tipoIdaVuelta = tipoViaje;
    },
    SET_LISTA_SOLICITUDES(state, solicitudes) {
      state.solicitudes = solicitudes;
    },
  },
  actions: {
    async getTramosAppVuelta({ commit }, data_) {
      let response = [];
      await apolloClient
        .query({
          query: GET_TRAMOS_APP_VUELTA,
          variables: data_,
          fetchPolicy: "network-only",
        })
        .then((res) => {
          if (!res.loading) response = res.data.GetTramosAppVuelta;
        });
        commit("GET_TRAMOS_APP_VUELTA_LIST", response);
        return response;
    },
    async getPlanificacionTransporte({ commit }, data_) {
      const params = {
        query: GET_PLANIFICACIONES,
        variables: data_,
        fetchPolicy: "network-only",
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.GetPlanificacionesApp;
        commit("SET_PLANIFICACIONES", response);
      } catch (e) {
        console.log("Falla error, getPlanificacionTransporte ", e);
      }

      return response;
    },

    async getPlanificacionId({ commit }, data_) {
      let response = null;
      let params = {
        query: GET_PLANIFICACION_ID,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.getOnePlanificacionID;
        });
      } catch (e) {
        console.log("Falla error, getPlanificacionId ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_PLANIFICACION", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async getUsuario({ commit }, data_) {
      let response = null;
      let params = {
        query: GET_USUARIO,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.usuario;
        });
      } catch (e) {
        console.log("Falla error, getUsuario ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_USUARIO", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async getSolicitudesTransporte({ commit }, data_) {
      const params = {
        query: GET_SOLICITUDES_USUARIO,
        variables: data_,
        fetchPolicy: "network-only",
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.FindSolicitudesRecientesUsuario;
        commit("SET_LISTA_SOLICITUDES", response);
      } catch (error) {
        console.log("Error en getFindSolicitudes:", error);
      }
      return response;
    },

    async getTurnos({ commit }, data_) {
      let response = null;
      let params = {
        query: GET_TURNOS,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.turnos;
        });
      } catch (e) {
        console.log("Falla error, getTurnos ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_TURNOS", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async getTeams({ commit }, data_) {
      let response = null;
      let params = {
        query: GET_TEAMS,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.teams;
        });
      } catch (e) {
        console.log("Falla error, getTeams ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_TEAMS", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async getTipoTransporte({ commit }, vars) {
      try {
        exQue(GET_TIPO_TRANSPORTE_EMPRESA, vars).then((res) => {
          commit("SET_TIPO_TRANSPORTE", res);
        });
      } catch (e) {
        console.log("Falla error, getTipoTransporte ", e);
      }
    },

    async getTramos({ commit }, data_) {
      let response = null;
      let params = {
        query: GET_TRAMOS,
        variables: data_,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.GetTramosApp;
        });
      } catch (e) {
        console.log("Falla error, getTramos ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_TRAMOS_TRANSPORTE", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async getTipoIdaVuelta({ commit }, data_) {
      let response = null;
      let params = {
        query: GET_TIPO_IDA_VUELTA,
        variables: data_,
        fetchPolicy: "network-only",
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.tipoIdaVuelta;
        });
      } catch (e) {
        console.log("Falla error, getTipoIdaVuelta ", e);
      }
      return new Promise((resolve) => {
        if (response != null) {
          if (response.length == 0) {
            resolve(false);
          } else {
            resolve(response);
            commit("SET_TIPO_IDA_VUELTA", response);
          }
        } else {
          resolve(false);
        }
      });
    },

    async crearInscripcion(_, data_) {
      const params = {
        mutation: CREAR_INSCRIPCION_TRAMO,
        variables: data_,
        errorPolicy: "all",
      };

      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res;
      } catch (e) {
        console.log("Falla metodo crearInscripcion: ", e);
      }

      return response;
    },
    async cancelSolicitud(_, { idSolicitud, idEmpresa, idUsuario }) {
      return await exMut(CANCELAR_INSCRIPCION_TRAMO, {
        idSolicitud,
        idEmpresa,
        idUsuario,
      })
        .then(() => {
          return true;
        })
        .catch((e) => {
          console.log("Error en cancelSolicitud", e);
          return false;
        });
    },
  },
};
